import { baseUrls } from "./consts";

export default function apiUrl(path) {
    return baseUrls + path;
}
